<mat-dialog-content>
    <mat-spinner diameter="18" class="spinner"></mat-spinner>
    {{ message }}
</mat-dialog-content>